export default __webpack_public_path__ + "static/media/article-grey.1d8c31a7.svg";